import classNames from 'classnames';
import React from 'react';

export type LabelProps = {
  title: React.ReactNode | React.ReactNodeArray;
  children?: React.ReactNode | React.ReactNodeArray;
  htmlFor?: string;
  isHidden?: boolean;
};

export function Label(props: LabelProps) {
  let { title, children, isHidden, htmlFor } = props;

  return (
    <div>
      <div
        className={classNames('block text-sm text-gray-500 font-medium py-1 whitespace-nowrap', {
          'visually-hidden': isHidden,
        })}
      >
        {title}
      </div>
      {children}
    </div>
  );
}

export function InputLabel(props: LabelProps) {
  let { htmlFor } = props;

  return (
    <label htmlFor={htmlFor} role="presentation">
      <Label {...props} />
    </label>
  );
}
